!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react"), require("prop-types")) : "function" == typeof define && define.amd ? define(["exports", "react", "prop-types"], t) : t((e = e || self)["react-easy-edit"] = {}, e.React, e.PropTypes);
}(this, function (e, t, n) {
  "use strict";

  var h = "default" in t ? t.default : t;
  function a(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  function s(e, t) {
    for (var n = 0; n < t.length; n++) {
      var a = t[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  function o(e, t, n) {
    return t && s(e.prototype, t), n && s(e, n), e;
  }
  function r(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  function p() {
    return (p = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var a in n) {
          Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
        }
      }
      return e;
    }).apply(this, arguments);
  }
  function l(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && u(e, t);
  }
  function i(e) {
    return (i = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }
  function u(e, t) {
    return (u = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }
  function c(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function f(e, t) {
    return !t || "object" != typeof t && "function" != typeof t ? c(e) : t;
  }
  n = n && n.hasOwnProperty("default") ? n.default : n;
  !function (e, t) {
    void 0 === t && (t = {});
    var n = t.insertAt;
    if (e && "undefined" != typeof document) {
      var a = document.head || document.getElementsByTagName("head")[0],
        s = document.createElement("style");
      s.type = "text/css", "top" === n && a.firstChild ? a.insertBefore(s, a.firstChild) : a.appendChild(s), s.styleSheet ? s.styleSheet.cssText = e : s.appendChild(document.createTextNode(e));
    }
  }(".easy-edit-button-wrapper{display:inline}.easy-edit-hover-on{cursor:pointer;font-style:italic}.easy-edit-radio-label{display:block}.easy-edit-not-allowed{cursor:not-allowed}.easy-edit-checkbox-label{display:block}.easy-edit-textarea{min-height:40px}.easy-edit-button{border:none;display:inline-block;margin:0 2px;padding:4px;text-align:center;text-decoration:none}.easy-edit-component-wrapper{display:inline-grid}.easy-edit-validation-error{color:red}");
  function v(e) {
    var t = e.options,
      n = e.value,
      a = e.onChange,
      s = e.placeholder,
      o = e.attributes,
      r = e.cssClassPrefix,
      l = e.onFocus,
      i = e.onBlur;
    return h.createElement("div", {
      className: r + "easy-edit-component-wrapper"
    }, h.createElement("select", p({
      value: n || "",
      onChange: a,
      onFocus: l,
      onBlur: i
    }, o), h.createElement("option", {
      key: "",
      value: "",
      disabled: "disabled"
    }, s), t.map(function (e) {
      return h.createElement("option", {
        value: e.value,
        key: e.value
      }, e.label);
    })));
  }
  var E = Object.freeze({
    DEFAULT_PLACEHOLDER: "Click to edit",
    DEFAULT_SELECT_PLACEHOLDER: "Select ...",
    DEFAULT_SAVE_BUTTON_LABEL: "Save",
    DEFAULT_CANCEL_BUTTON_LABEL: "Cancel",
    DEFAULT_DELETE_BUTTON_LABEL: "Delete",
    DEFAULT_BUTTON_CSS_CLASS: "easy-edit-button",
    DEFAULT_ON_HOVER_CSS_CLASS: "easy-edit-hover-on",
    ERROR_UNSUPPORTED_TYPE: "Unsupported component type, please review documentation for supported HTML component types",
    FAILED_VALIDATION_MESSAGE: "Please provide a valid value",
    POSITION_AFTER: "after",
    POSITION_BEFORE: "before"
  });
  v.propTypes = {
    options: n.array.isRequired,
    onChange: n.func,
    value: n.oneOfType([n.string, n.number]),
    placeholder: n.string,
    attributes: n.object,
    cssClassPrefix: n.string,
    onFocus: n.func,
    onBlur: n.func
  }, v.defaultProps = {
    attributes: {},
    placeholder: E.DEFAULT_SELECT_PLACEHOLDER
  };
  function C(e) {
    var t = e.type,
      n = e.value,
      a = e.placeholder,
      s = e.onChange,
      o = e.attributes,
      r = e.cssClassPrefix,
      l = e.onFocus,
      i = e.onBlur;
    return h.createElement("div", {
      className: r + "easy-edit-component-wrapper"
    }, h.createElement("input", p({
      autoFocus: o.autoFocus || !0,
      type: t,
      value: n || void 0,
      onChange: s,
      onFocus: l,
      onBlur: i,
      placeholder: o.placeholder || a,
      autoComplete: o.autoComplete || "off"
    }, o)));
  }
  C.propTypes = {
    type: n.string.isRequired,
    onChange: n.func,
    value: n.string,
    placeholder: n.string,
    attributes: n.object,
    cssClassPrefix: n.string,
    onFocus: n.func,
    onBlur: n.func
  }, C.defaultProps = {
    attributes: {},
    placeholder: E.DEFAULT_PLACEHOLDER,
    onfocus: function onfocus() {}
  };
  function m(e) {
    var t = e.value,
      n = e.placeholder,
      a = e.onChange,
      s = e.attributes,
      o = e.cssClassPrefix,
      r = e.onFocus,
      l = e.onBlur;
    return h.createElement("div", {
      className: o + "easy-edit-component-wrapper"
    }, h.createElement("textarea", p({
      autoFocus: s.autoFocus || !0,
      value: t,
      onChange: a,
      onFocus: r,
      onBlur: l,
      placeholder: n
    }, s, {
      className: void 0 !== s.className ? s.className + " easy-edit-textarea" : "easy-edit-textarea"
    })));
  }
  m.propTypes = {
    onChange: n.func,
    value: n.string,
    placeholder: n.string,
    attributes: n.object,
    cssClassPrefix: n.string,
    onBlur: n.func,
    onFocus: n.func
  }, m.defaultProps = {
    attributes: {},
    placeholder: E.DEFAULT_PLACEHOLDER
  };
  function b(e) {
    var t = e.options,
      n = e.value,
      a = e.onChange,
      s = e.attributes,
      o = e.cssClassPrefix,
      r = e.onFocus,
      l = e.onBlur,
      i = t.map(function (e) {
        return h.createElement("label", {
          key: e.value,
          className: o + "easy-edit-radio-label"
        }, h.createElement("input", p({
          type: "radio",
          value: e.value,
          onChange: a,
          onFocus: r,
          onBlur: l,
          checked: e.value === n
        }, s)), e.label);
      });
    return h.createElement("div", null, i);
  }
  b.propTypes = {
    onChange: n.func,
    value: n.oneOfType([n.string, n.number]),
    attributes: n.object,
    cssClassPrefix: n.string,
    onFocus: n.func,
    onBlur: n.func
  }, b.defaultProps = {
    attributes: {}
  };
  function y(e) {
    var t = e.options,
      n = e.value,
      a = e.onChange,
      s = e.attributes,
      o = e.cssClassPrefix,
      r = e.onFocus,
      l = e.onBlur;
    n = n || [];
    var i = t.map(function (e) {
      return h.createElement("label", {
        key: e.value,
        className: o + "easy-edit-checkbox-label"
      }, h.createElement("input", p({}, s, {
        type: "checkbox",
        value: e.value,
        key: e.value,
        onChange: a,
        onFocus: r,
        onBlur: l,
        checked: n.includes(e.value)
      })), e.label);
    });
    return h.createElement("div", null, i);
  }
  y.propTypes = {
    onChange: n.func,
    options: n.array.isRequired,
    value: n.array,
    attributes: n.object,
    cssClassPrefix: n.string,
    onFocus: n.func,
    onBlur: n.func
  }, y.defaultProps = {
    attributes: {}
  };
  function T(e) {
    var t = e.value,
      n = void 0 === t ? "" : t,
      a = e.onChange,
      s = e.attributes,
      o = e.cssClassPrefix,
      r = e.onFocus,
      l = e.onBlur;
    return h.createElement("div", {
      className: o + "easy-edit-component-wrapper"
    }, h.createElement("input", p({
      type: "color",
      defaultValue: n,
      onChange: a,
      onFocus: r,
      onBlur: l
    }, s)));
  }
  T.propTypes = {
    onChange: n.func,
    value: n.string,
    attributes: n.object,
    cssClassPrefix: n.string,
    onFocus: n.func,
    onBlur: n.func
  }, T.defaultProps = {
    attributes: {}
  };
  function g(e) {
    var t = e.options,
      n = e.value,
      a = e.onChange,
      s = e.attributes,
      o = e.placeholder,
      r = e.cssClassPrefix,
      l = e.onFocus,
      i = e.onBlur,
      u = h.createRef(),
      c = t.map(function (e) {
        return h.createElement("option", {
          key: e.value,
          value: e.label
        });
      });
    return h.createElement("div", {
      className: r + "easy-edit-component-wrapper"
    }, h.createElement("input", p({
      autoFocus: s.autoFocus || !0,
      value: n || void 0,
      onChange: a,
      onFocus: l,
      onBlur: i,
      placeholder: o,
      autoComplete: s.autoComplete || "off"
    }, s, {
      list: u
    })), h.createElement("datalist", {
      id: u
    }, c));
  }
  g.propTypes = {
    onChange: n.func,
    value: n.oneOfType([n.string, n.number]),
    attributes: n.object,
    cssClassPrefix: n.string,
    onFocus: n.func,
    onBlur: n.func
  }, g.defaultProps = {
    attributes: {}
  };
  var B = function () {
      function n(e) {
        var t;
        return a(this, n), (t = f(this, i(n).call(this, e))).state = {
          value: e.value
        }, t.setValue = t.setValue.bind(c(t)), t;
      }
      return l(n, t.Component), o(n, [{
        key: "setValue",
        value: function value(e) {
          var t = this;
          this.setState({
            value: e
          }, function () {
            return t.props.setValue(e);
          });
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.state.value,
            t = this.props,
            n = t.children,
            a = t.cssClassPrefix,
            s = h.cloneElement(h.Children.only(n), {
              setParentValue: this.setValue,
              value: e
            });
          return h.createElement("div", {
            className: a + "easy-edit-component-wrapper"
          }, s);
        }
      }]), n;
    }(),
    d = function () {
      function d(e) {
        var s;
        return a(this, d), r(c(s = f(this, i(d).call(this, e))), "onKeyDown", function (e) {
          var t = s.props,
            n = t.type,
            a = t.disableAutoSubmit;
          t.disableAutoCancel || 27 !== e.keyCode || s._onCancel(), a || (13 === e.keyCode && n !== A.TEXTAREA || 13 === e.keyCode && e.ctrlKey && n === A.TEXTAREA) && s._onSave();
        }), r(c(s), "_onSave", function () {
          var e = s.props,
            t = e.onSave,
            n = e.onValidate,
            a = s.state.tempValue;
          n(a) ? s.setState({
            editing: !1,
            value: a,
            isValid: !0,
            hover: !1
          }, function () {
            return t(s.state.value);
          }) : s.setState({
            isValid: !1
          });
        }), r(c(s), "_onBlur", function () {
          var e = s.props,
            t = e.onBlur;
          e.saveOnBlur ? (t(s.state.tempValue), s._onSave()) : t(s.state.tempValue);
        }), r(c(s), "_onFocus", function () {
          var e = s.props.onFocus;
          e && e(s.state.tempValue);
        }), r(c(s), "_onCancel", function () {
          var e = s.props.onCancel,
            t = s.state.value;
          s.setState({
            editing: !1,
            tempValue: t,
            hover: !1
          }, function () {
            return e();
          });
        }), r(c(s), "_onDelete", function () {
          var e = s.props.onDelete,
            t = s.state.value;
          s.setState({
            editing: !1,
            tempValue: t,
            hover: !1,
            isHidden: !0
          }, function () {
            return e();
          });
        }), r(c(s), "onChange", function (e) {
          s.setState({
            tempValue: e.target ? e.target.value : e
          });
        }), r(c(s), "onCheckboxChange", function (e) {
          var t = s.props.options,
            n = s.state.tempValue || [];
          e.target.checked && !n.includes(e.target.value) ? n.push(e.target.value) : n.splice(n.indexOf(e.target.value), 1);
          var a = t.map(function (e) {
            return e.value;
          });
          n = n.filter(function (e) {
            return a.includes(e);
          }), s.setState({
            tempValue: n
          });
        }), r(c(s), "onClick", function () {
          s.props.allowEdit && s.setState({
            editing: !0
          });
        }), r(c(s), "hoverOn", function () {
          s.props.allowEdit && s.setState({
            hover: !0
          });
        }), r(c(s), "hoverOff", function () {
          s.setState({
            hover: !1
          });
        }), s.state = {
          editing: e.editMode || !1,
          hover: !1,
          value: e.value,
          tempValue: e.value,
          isValid: !0,
          isHidden: !1
        }, s.saveButton = h.createRef(), s.cancelButton = h.createRef(), s.deleteButton = h.createRef(), s;
      }
      return l(d, h.Component), o(d, [{
        key: "componentDidUpdate",
        value: function value(e) {
          this.props.value !== e.value && this.setState({
            tempValue: this.props.value,
            value: this.props.value
          });
        }
      }, {
        key: "renderInput",
        value: function value() {
          var e = this.props,
            t = e.type,
            n = e.options,
            a = e.placeholder,
            s = e.attributes,
            o = e.editComponent,
            r = e.cssClassPrefix,
            l = this.state.editing;
          if (this.cullAttributes(), h.isValidElement(o)) return h.createElement(B, {
            setValue: this.onChange,
            value: this.state.tempValue,
            cssClassPrefix: r
          }, o);
          switch (t) {
            case A.TEXT:
            case A.PASSWORD:
            case A.EMAIL:
            case A.NUMBER:
            case A.DATE:
            case A.DATETIME_LOCAL:
            case A.TIME:
            case A.MONTH:
            case A.WEEK:
            case A.RANGE:
              return h.createElement(C, {
                value: l ? this.state.tempValue : this.state.value,
                placeholder: a,
                onChange: this.onChange,
                onFocus: this._onFocus(),
                onBlur: this._onBlur,
                type: t,
                attributes: s,
                cssClassPrefix: r
              });
            case A.COLOR:
              return h.createElement(T, {
                value: l ? this.state.tempValue : this.state.value,
                onChange: this.onChange,
                onFocus: this._onFocus(),
                onBlur: this._onBlur,
                attributes: s,
                cssClassPrefix: r
              });
            case A.TEXTAREA:
              return h.createElement(m, {
                value: l ? this.state.tempValue : this.state.value,
                placeholder: a,
                onChange: this.onChange,
                onFocus: this._onFocus(),
                onBlur: this._onBlur,
                attributes: s,
                cssClassPrefix: r
              });
            case A.SELECT:
              return h.createElement(v, {
                value: l ? this.state.tempValue : this.state.value,
                onChange: this.onChange,
                onFocus: this._onFocus(),
                onBlur: this._onBlur,
                options: n,
                placeholder: a === E.DEFAULT_PLACEHOLDER ? E.DEFAULT_SELECT_PLACEHOLDER : a,
                attributes: s,
                cssClassPrefix: r
              });
            case A.RADIO:
              return h.createElement(b, {
                value: l ? this.state.tempValue : this.state.value,
                onChange: this.onChange,
                onFocus: this._onFocus(),
                onBlur: this._onBlur,
                options: n,
                attributes: s,
                cssClassPrefix: r
              });
            case A.CHECKBOX:
              return h.createElement(y, {
                value: l ? this.state.tempValue : this.state.value,
                onChange: this.onCheckboxChange,
                onFocus: this._onFocus(),
                onBlur: this._onBlur,
                options: n,
                attributes: s,
                cssClassPrefix: r
              });
            case A.DATALIST:
              return h.createElement(g, {
                value: l ? this.state.tempValue : this.state.value,
                onChange: this.onChange,
                onFocus: this._onFocus(),
                onBlur: this._onBlur,
                options: n,
                attributes: s,
                cssClassPrefix: r
              });
            default:
              throw new Error(E.ERROR_UNSUPPORTED_TYPE);
          }
        }
      }, {
        key: "renderButtons",
        value: function value() {
          var e = this.props,
            t = e.saveOnBlur,
            n = e.saveButtonLabel,
            a = e.saveButtonStyle,
            s = e.cancelButtonLabel,
            o = e.cancelButtonStyle,
            r = e.deleteButtonLabel,
            l = e.deleteButtonStyle,
            i = e.cssClassPrefix,
            u = e.hideSaveButton,
            c = e.hideCancelButton,
            p = e.hideDeleteButton;
          return h.createElement("div", {
            className: i + "easy-edit-button-wrapper"
          }, !u && d.generateButton(this.saveButton, this._onSave, n, null === a ? i + E.DEFAULT_BUTTON_CSS_CLASS : a, "save", t), !c && d.generateButton(this.cancelButton, this._onCancel, s, null === o ? i + E.DEFAULT_BUTTON_CSS_CLASS : o, "cancel", t), !p && d.generateButton(this.deleteButton, this._onDelete, r, null === l ? i + E.DEFAULT_BUTTON_CSS_CLASS : l, "delete", t));
        }
      }, {
        key: "renderValidationMessage",
        value: function value() {
          var e = this.props,
            t = e.validationMessage,
            n = e.cssClassPrefix;
          if (!this.state.isValid) return h.createElement("div", {
            className: n + "easy-edit-validation-error"
          }, t);
        }
      }, {
        key: "renderInstructions",
        value: function value() {
          var e = this.props,
            t = e.instructions,
            n = e.cssClassPrefix,
            a = e.editMode;
          if ((this.state.editing || a) && null !== t) return h.createElement("div", {
            className: n + "easy-edit-instructions"
          }, t);
        }
      }, {
        key: "setCssClasses",
        value: function value(e) {
          var t = this.props,
            n = t.viewAttributes,
            a = t.cssClassPrefix,
            s = t.onHoverCssClass;
          return n.class && (e += " " + n.class), n.className && (e += " " + n.className), this.props.allowEdit ? this.state.hover ? s === E.DEFAULT_ON_HOVER_CSS_CLASS ? a + "easy-edit-hover-on " + e : s + " " + e : e : a + "easy-edit-not-allowed " + e;
        }
      }, {
        key: "renderPlaceholder",
        value: function value() {
          var e = this.props,
            t = e.type,
            n = e.placeholder,
            a = e.displayComponent,
            s = e.viewAttributes,
            o = e.cssClassPrefix;
          this.cullAttributes();
          var r = o + "easy-edit-wrapper";
          if (h.isValidElement(a)) return h.createElement("div", p({}, s, {
            className: this.setCssClasses(r),
            onClick: this.onClick,
            onMouseEnter: this.hoverOn,
            onMouseLeave: this.hoverOff
          }), this.state.value ? h.cloneElement(a, {
            value: this.state.value
          }) : n);
          switch (t) {
            case A.TEXT:
            case A.DATALIST:
            case A.EMAIL:
            case A.TEXTAREA:
            case A.NUMBER:
            case A.DATE:
            case A.DATETIME_LOCAL:
            case A.TIME:
            case A.MONTH:
            case A.WEEK:
            case A.RANGE:
            case A.PASSWORD:
              return h.createElement("div", p({}, s, {
                className: this.setCssClasses(r),
                onClick: this.onClick,
                onMouseEnter: this.hoverOn,
                onMouseLeave: this.hoverOff
              }), this.state.value ? t === A.PASSWORD ? "••••••••" : this.state.value : n);
            case A.RADIO:
            case A.CHECKBOX:
            case A.SELECT:
              return h.createElement("div", p({}, s, {
                className: this.setCssClasses(r),
                onClick: this.onClick,
                onMouseEnter: this.hoverOn,
                onMouseLeave: this.hoverOff
              }), this.renderComplexView());
            case A.COLOR:
              return h.createElement("input", p({}, s, {
                type: t,
                value: this.state.value,
                onClick: this.onClick,
                readOnly: !0
              }));
            default:
              throw new Error(E.ERROR_UNSUPPORTED_TYPE);
          }
        }
      }, {
        key: "renderComplexView",
        value: function value() {
          var e,
            t = this,
            n = this.props,
            a = n.placeholder,
            s = n.options,
            o = n.type;
          return null === this.state.value || 0 === this.state.value.length ? a : 0 !== (e = A.CHECKBOX === o ? s.filter(function (e) {
            return t.state.value.includes(e.value);
          }) : s.filter(function (e) {
            return t.state.value === e.value;
          })).length ? e.map(function (e) {
            return e.label;
          }).join(", ") : this.state.value;
        }
      }, {
        key: "cullAttributes",
        value: function value() {
          var e = this.props.attributes;
          delete e.type, delete e.onChange, delete e.value;
        }
      }, {
        key: "render",
        value: function value() {
          var t = this,
            e = this.props,
            n = e.cssClassPrefix,
            a = e.buttonsPosition,
            s = e.editMode;
          return this.state.isHidden ? "" : this.state.editing || s ? h.createElement("div", {
            className: n + "easy-edit-inline-wrapper",
            tabIndex: "0",
            onKeyDown: function onKeyDown(e) {
              return t.onKeyDown(e);
            }
          }, a === E.POSITION_BEFORE && this.renderButtons(), this.renderInput(), a === E.POSITION_AFTER && this.renderButtons(), this.renderInstructions(), this.renderValidationMessage()) : this.renderPlaceholder();
        }
      }], [{
        key: "generateButton",
        value: function value(e, t, n, a, s, o) {
          return o ? "" : h.createElement("button", {
            ref: e,
            onClick: t,
            className: a,
            name: s
          }, n);
        }
      }]), d;
    }(),
    A = {
      COLOR: "color",
      CHECKBOX: "checkbox",
      DATALIST: "datalist",
      DATE: "date",
      DATETIME_LOCAL: "datetime-local",
      EMAIL: "email",
      MONTH: "month",
      NUMBER: "number",
      PASSWORD: "password",
      RADIO: "radio",
      RANGE: "range",
      SELECT: "select",
      TEXT: "text",
      TEXTAREA: "textarea",
      TIME: "time",
      WEEK: "week"
    };
  Object.freeze(A), d.propTypes = {
    type: n.oneOf(["text", "number", "color", "textarea", "date", "datetime-local", "email", "password", "time", "month", "week", "radio", "checkbox", "select", "range", "datalist"]).isRequired,
    value: n.oneOfType([n.string, n.number, n.array, n.object]),
    options: n.array,
    saveButtonLabel: n.oneOfType([n.string, n.element]),
    saveButtonStyle: n.string,
    cancelButtonLabel: n.oneOfType([n.string, n.element]),
    cancelButtonStyle: n.string,
    deleteButtonLabel: n.oneOfType([n.string, n.element]),
    deleteButtonStyle: n.string,
    buttonsPosition: n.oneOf(["after", "before"]),
    placeholder: n.string,
    onCancel: n.func,
    onDelete: n.func,
    onValidate: n.func,
    onFocus: n.func,
    onBlur: n.func,
    onSave: n.func.isRequired,
    validationMessage: n.string,
    allowEdit: n.bool,
    attributes: n.object,
    viewAttributes: n.object,
    instructions: n.string,
    editComponent: n.element,
    displayComponent: n.element,
    disableAutoSubmit: n.bool,
    disableAutoCancel: n.bool,
    cssClassPrefix: n.string,
    hideSaveButton: n.bool,
    hideCancelButton: n.bool,
    hideDeleteButton: n.bool,
    onHoverCssClass: n.string,
    saveOnBlur: n.bool,
    editMode: n.bool
  }, d.defaultProps = {
    value: null,
    saveButtonLabel: E.DEFAULT_SAVE_BUTTON_LABEL,
    saveButtonStyle: null,
    cancelButtonLabel: E.DEFAULT_CANCEL_BUTTON_LABEL,
    cancelButtonStyle: null,
    deleteButtonLabel: E.DEFAULT_DELETE_BUTTON_LABEL,
    deleteButtonStyle: null,
    buttonsPosition: E.POSITION_AFTER,
    placeholder: E.DEFAULT_PLACEHOLDER,
    allowEdit: !0,
    onCancel: function onCancel() {},
    onDelete: function onDelete() {},
    onfocus: function onfocus() {},
    onBlur: function onBlur() {},
    onValidate: function onValidate() {
      return !0;
    },
    validationMessage: E.FAILED_VALIDATION_MESSAGE,
    attributes: {},
    viewAttributes: {},
    instructions: null,
    editComponent: null,
    placeholderComponent: null,
    disableAutoSubmit: !1,
    disableAutoCancel: !1,
    cssClassPrefix: "",
    hideSaveButton: !1,
    hideCancelButton: !1,
    hideDeleteButton: !0,
    onHoverCssClass: E.DEFAULT_ON_HOVER_CSS_CLASS,
    saveOnBlur: !1,
    editMode: !1
  }, e.Types = A, e.default = d, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});